import { render, staticRenderFns } from "./CustomQuestionAnswerRadio.vue?vue&type=template&id=4afa3976"
import script from "./CustomQuestionAnswerRadio.vue?vue&type=script&lang=js"
export * from "./CustomQuestionAnswerRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports